/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import { alpha, type Theme } from '@mui/material';

const INK = '#0F172A';

/** The v4 mockups' ghost pill button (`.btn.ghost`), used for every outlined primary button. */
export const getGhostButtonSx = (theme: Theme) => {
  const isDark = theme.palette.mode === 'dark';
  const { white } = theme.palette.common;
  return {
    borderRadius: 999,
    paddingInline: 14,
    fontSize: 12.5,
    fontWeight: 550,
    textTransform: 'none',
    color: isDark ? '#EAF0FF' : INK,
    backgroundColor: isDark ? alpha(white, 0.06) : alpha(INK, 0.054),
    border: `1px solid ${isDark ? alpha(white, 0.1) : alpha(INK, 0.09)}`,
    '&:hover': {
      backgroundColor: isDark ? alpha(white, 0.1) : alpha(INK, 0.08),
      borderColor: isDark ? alpha(white, 0.16) : alpha(INK, 0.14),
    },
    '&.Mui-disabled': {
      borderColor: isDark ? alpha(white, 0.06) : alpha(INK, 0.06),
    },
  } as const;
};
